export class BurgerMenu {
  private readonly trigger: HTMLElement;
  private readonly layer: HTMLElement;
  private readonly bodyElem: HTMLElement;

  constructor() {
    console.log('BurgerMenu initialized');
    const trigger = document.getElementById('lp_mainmenu_toggle');
    const layer = document.getElementById('mainmenu_layer');
    if (!trigger || !layer) return;

    this.trigger = trigger;
    this.layer = layer;
    this.bodyElem = document.body;

    this.trigger.addEventListener('click', () => this.toggle());

    // Escape-Taste schließt das Menü und gibt Fokus zurück an den Trigger
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen()) {
        this.close();
        this.trigger.focus();
      }
    });

    // Klick außerhalb des Menüs schließt es.
    // trigger.contains() fängt Klicks auf Kind-Elemente (z.B. <img>) ab.
    document.addEventListener('click', (e) => {
      if (this.isOpen() && !this.layer.contains(e.target as Node) && !this.trigger.contains(e.target as Node)) {
        this.close();
      }
    });

    // Links im Menü schließen das Menü beim Navigieren
    this.layer.addEventListener('click', (e) => {
      if ((e.target as HTMLElement).closest('a')) {
        this.close();
      }
    });

    // Menü initial: alle fokussierbaren Elemente im Layer deaktivieren
    this.setFocusable(false);
  }

  private isOpen(): boolean {
    return this.layer.classList.contains('mainmenu-layer__open');
  }

  private toggle(): void {

    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  }

  private open(): void {
    this.layer.classList.add('mainmenu-layer__open');
    this.layer.setAttribute('aria-hidden', 'false');
    this.trigger.setAttribute('aria-expanded', 'true');
    this.trigger.setAttribute('aria-label', 'Hauptmenü schließen');
    this.trigger.classList.add('mainmenu-trigger__active', 'lbbw-icf--close');
    this.bodyElem.classList.add('openflyout');
    this.setFocusable(true);

    // Fokus auf erstes fokussierbares Element im Menü legen
    const firstFocusable = this.getFocusableItems()[0];
    firstFocusable?.focus();
  }

  close(): void {
    this.layer.classList.remove('mainmenu-layer__open');
    this.layer.setAttribute('aria-hidden', 'true');
    this.trigger.setAttribute('aria-expanded', 'false');
    this.trigger.setAttribute('aria-label', 'Hauptmenü öffnen');
    this.trigger.classList.remove('mainmenu-trigger__active', 'lbbw-icf--close');
    this.bodyElem.classList.remove('openflyout');
    this.setFocusable(false);
  }

  /** Aktiviert oder deaktiviert alle fokussierbaren Elemente im Menü-Layer */
  private setFocusable(enabled: boolean): void {
    this.getFocusableItems().forEach((el) => {
      if (enabled) {
        el.removeAttribute('tabindex');
      } else {
        el.setAttribute('tabindex', '-1');
      }
    });
  }

  private getFocusableItems(): HTMLElement[] {
    return Array.from(
      this.layer.querySelectorAll<HTMLElement>(
        'a, button, [tabindex]:not([tabindex="-1"])'
      )
    );
  }
}
